import { render, staticRenderFns } from "./UpdatedNotice.vue?vue&type=template&id=1ef807d6"
import script from "./UpdatedNotice.js?vue&type=script&lang=js&external"
export * from "./UpdatedNotice.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports